import { lazy } from "react";
import { Users as UsersIcon } from "@volt_developers/react-ui-components";
import { Route } from "../RouteModel";

const UserList = lazy(() => import("./../../pages/configuration/users/List"));
const UserDetails = lazy(
  () => import("./../../pages/configuration/users/Details")
);
const UserEdit = lazy(() => import("./../../pages/configuration/users/Edit"));
const UserCreate = lazy(
  () => import("./../../pages/configuration/users/Create")
);

export const userRoutes: Route = {
  path: "/configuration/users",
  i18nName: "Users",
  icon: UsersIcon,
  component: UserList,
  showChildrenInSidebar: false,
  can: {
    do: "list",
    on: "user",
  },
  children: [
    {
      path: "/configuration/users/create",
      i18nName: "Create user",
      component: UserCreate,
      can: {
        do: "create",
        on: "user",
      },
    },
    {
      path: "/configuration/users/:id/edit",
      i18nName: "Edit user",
      component: UserEdit,
      can: {
        do: "update",
        on: "user",
      },
    },
    {
      path: "/configuration/users/:id",
      i18nName: "User",
      component: UserDetails,
      can: {
        do: "details",
        on: "user",
      },
    },
  ],
};
